import LabelLang from "component/LabelLang/label-lang";
import Mailto from "component/shared/mailto";
import { useSelector } from "react-redux";

const OfficesList = ({
  officeName,
  address,
  phoneNumber,
  mail,
  regionalOfficeTranslations = [],
}) => {

  const dir = useSelector(({ theme }) => theme.direction);

  return (
    <div className="item-cont-list">
      <LabelLang
        id="name"
        defaultValue={officeName}
        translations={regionalOfficeTranslations}
      />
      {/* <h6>
          <TextSlicer
            txt={
              LabelLangString({
                id: "name",
                currentLocale: currentLocale,
                defaultValue: officeName,
                translations: regionalOfficeTranslations
              })
            }
            max={60}
          />
      </h6> */}
      <div className="item-cont">
        <img
          loading="lazy"
          src={process.env.PUBLIC_URL + "/image/cont1.svg"}
          alt="cont"
        />
        <span>
          {address ? (
            <LabelLang
              id="address"
              defaultValue={address}
              translations={regionalOfficeTranslations}
            />
          ) : (
            // <label>
            //   <TextSlicer
            //     txt={
            //       LabelLangString({
            //         id: "name",
            //         currentLocale: currentLocale,
            //         defaultValue: officeName,
            //         translations: regionalOfficeTranslations
            //       })
            //     }
            //     max={60}
            //   />
            // </label>
            <FormattedMessage id="data-not-found" />
          )}
        </span>
      </div>
      <div className="item-cont">
        <img
          loading="lazy"
          src={process.env.PUBLIC_URL + "/image/cont2.svg"}
          alt="cont"
        />
        <span dir="ltr" className={dir === 'rtl' ? 'text-end' : 'text-start'}>
          {phoneNumber ? phoneNumber : <FormattedMessage id="data-not-found" />}
        </span>
      </div>
      <div className="item-cont">
        <img
          loading="lazy"
          src={process.env.PUBLIC_URL + "/image/cont3.svg"}
          alt="cont"
        />
        {mail ? (
          <Mailto email={mail}>{mail}</Mailto>
        ) : (
          <span>
            {" "}
            <FormattedMessage id="data-not-found" />{" "}
          </span>
        )}
      </div>
    </div>
  );
};

export default OfficesList;
